import dynamic from "next/dynamic";

export const DynamicGiftProductSkeleton = dynamic(() =>
    import('./GiftProductSkeleton').then(({ GiftProductSkeleton }) => GiftProductSkeleton)
);